import axios from "axios";
import React, {
  useEffect,
  useImperativeHandle,
  forwardRef,
  useState,
  useRef,
} from "react";
const FaSyncAlt = require("react-icons/fa").FaSyncAlt;

export type CaptchaRef = {
  regenerate: () => void;
};

interface CaptchaProps {
  onChange: (captchaId: string) => void;
}

const CAPTCHA_REFRESH_TIME = 115000; // 115 seconds

const Captcha = forwardRef<CaptchaRef, CaptchaProps>(({ onChange }, ref) => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [captchaImg, setCaptchaImg] = useState<string>("");
  const [captchaId, setCaptchaId] = useState<string>("");

  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const clearTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };

  const startExpiryTimer = () => {
    clearTimer();
    timerRef.current = setTimeout(() => {
      regenerate();
    }, CAPTCHA_REFRESH_TIME);
  };

  const generateCaptcha = async (): Promise<void> => {
    try {
      const response = await axios.get(`${baseUrl}api/generate-captcha`);

      if (response.data?.msg_code === 200) {
        setCaptchaImg(response.data.image_base64);
        setCaptchaId(response.data.captcha_id);
        onChange(response.data.captcha_id);

        startExpiryTimer()
      } else {
        resetCaptcha();
      }
    } catch (error) {
      console.error("Captcha API error:", error);
      resetCaptcha();
    }
  };

  const resetCaptcha = () => {
    clearTimer();
    setCaptchaImg("");
    setCaptchaId("");
    onChange("");
  };

  const regenerate = () => {
    clearTimer();
    generateCaptcha();
    onChange("");
  };

  useImperativeHandle(ref, () => ({
    regenerate,
  }));

  useEffect(() => {
    regenerate();

    return () => {
      clearTimer();
    };
  }, []);

  return (
    <div className="d-flex align-items-center justify-content-between">
      {captchaImg ? (
        <img
          src={`data:image/png;base64,${captchaImg}`}
          alt="captcha"
          style={{
            width: 200,
            height: 60,
            border: "1px solid #ccc",
            borderRadius: 4,
          }}
        />
      ) : (
        <div
          style={{
            width: 200,
            height: 60,
            border: "1px solid #ccc",
            borderRadius: 4,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#888",
            fontSize: 14,
          }}
        >
          Unable to load Captcha
        </div>
      )}

      <button
        type="button"
        className="btn btn-outline-secondary btn-md"
        title="Reload Captcha"
        onClick={regenerate}
      >
        <FaSyncAlt />
      </button>
    </div>

  );
});

export default Captcha;
